var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{staticClass:"general-info",attrs:{"open":_vm.isOpened},on:{"closeButtonClicked":_vm.onCloseButtonClicked}},[_vm._v("\n  Click the light bulbs to see who's fighting slavery and where they're helping. \n")])}
var staticRenderFns = []

export { render, staticRenderFns }